import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "gfu-block-editor__holder" }
const _hoisted_2 = {
  key: 0,
  class: "gfu-block-editor__tags"
}
const _hoisted_3 = {
  key: 0,
  class: "gfu-block-editor__actions"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_badge = _resolveComponent("base-badge")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['gfu-block-editor', $options.themeClass, { 'gfu-block-editor--nohover': $props.noHover, 'gfu-block-editor--disabled': $props.disabled }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "prefix"),
      _createElementVNode("div", {
        class: _normalizeClass(['gfu-block-editor__content-wrapper', { 'gfu-block-editor__content-wrapper--tags-compact': $props.tagsCompact }])
      }, [
        ($props.labels.length > 0 || _ctx.$slots.labels)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _renderSlot(_ctx.$slots, "labels"),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.labels, (label) => {
                return (_openBlock(), _createBlock(_component_base_badge, {
                  key: label.name,
                  class: "_mr-1 _my-1",
                  theme: label.theme,
                  "data-qa": `badge:${label.theme}-${label.name}`
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(label.name), 1 /* TEXT */)
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["theme", "data-qa"]))
              }), 128 /* KEYED_FRAGMENT */))
            ]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", {
          class: _normalizeClass($options.contentClass)
        }, [
          _renderSlot(_ctx.$slots, "default")
        ], 2 /* CLASS */)
      ], 2 /* CLASS */)
    ]),
    (_ctx.$slots.actions)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "actions")
        ]))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}